<template>
	<v-container>
        <v-dialog
            v-model="dialog"
            width="609"
            @click:outside="closeModal"
        >
            <v-card class="custom-card" rounded="0">
                <v-toolbar
                    color="secondary"
                    class="white--text"
                    >

                    <v-toolbar-title class="font-weight-bold">{{$t('animal.addNote')}}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon class="white--text" @click="closeModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                    <v-form 
                        autocomplete="off"
                        ref="form"
                        v-model="valid"
                        @submit.prevent="addNote"
                    >
				        <v-card-text class="black--text">
                            <label class="title" for="name">{{$t('animal.enterNote')}}</label>
                            <v-textarea
                                v-model="note"
                                :hint="$t('animal.enterNote')"
                                outlined
                                :rules=noteRules
                                counter
                                class="mt-3"
                            ></v-textarea>
                        
                        <v-card-actions class="">
                            <v-spacer></v-spacer>
                            <v-btn
                                class=""
                                outlined
                                color="primary"
                                @click="closeModal"
                                width="112"
                            >
                                {{$t('cancel')}}
                            </v-btn>
                            <v-btn type="submit" width="112" color="primary" class="btn-11 btn-22">
                                {{$t('submit')}}
                            </v-btn>
                        </v-card-actions>
                        </v-card-text>
                        </v-form>
				        
			        </v-card>
		        </v-dialog>
    </v-container>
</template>

<script>
import AnimalService from "@/_services/AnimalService"
import loading from "@/mixins/LoadingMixin";

export default {
        computed: {
            dialog() {
                return this.dialogI;
            }
        },
        data() {
            return {
                valid: true,
                note: '',
                noteRules: [
                    v => !!v || this.$t('animal.noteIsRequired'),
                    v => (v && v.length <= 50) || this.$t('animal.noteMustBeLessThan50Characters'),
                ],
            }
        },
        methods: {
            closeModal() {
                this.$emit('closeAddDept')
            },
            addNote() {
                if(!this.$refs.form.validate()) return;
                this.startLoading()
                AnimalService.createNote({ animalNumber: this.$route.params.animal_number, note: this.note })
                .then( respose => {
                    this.stopLoading()
                    if(respose.success){
                        this.$notify({
                            title: this.$t('animal.noteAdded'),
                            text: respose.message,
                            type: this.$t('success')
                        });
                        this.$emit('note:added', true)
                    }else{
                        console.log(respose)
                        this.$notify({
                            title: this.$t('animal.noteNotAdded'),
                            text: respose.message,
                            type: this.$t('error')
                        });
                        this.$emit('note:added', false)
                    }
                })
                .catch(error => {
                    this.stopLoading()
                    console.log('err', error)
                })
            }
        },

        props: ['dialogI'],
        mixins: [loading]
}
</script>
<style lang="scss" scoped>

</style>